
<template>
  <luma-empty>

    <luma-accounting-transaction></luma-accounting-transaction>
  </luma-empty>
</template>
<script>
    import LumaEmpty from "@/layout/LumaEmpty"
    import LumaAccountingTransaction from "./transaction_accounting/luma-accounting-transaction";

    export default {
        name: "accounting-transaction",
        components: {LumaAccountingTransaction, LumaEmpty}
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/accounting/accounting-transaction.vue